import React, { ReactElement } from "react";
import { Box, Button, Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: 7.75,
  },
}));
interface Props {
  onClick?: any;
  children: any;
  isGreen?: any;
  disable?: boolean;
  primary?: boolean;
  style?: any;
}

export default function CommonButton({
  onClick,
  children,
  isGreen = false,
  disable = false,
  primary,
  style,
}: Props): ReactElement {
  const classes = useStyles();
  return (
    <Box component="span" ml={1} mb={1}>
      <Button
        className={classes.button}
        variant="contained"
        color={primary ? "primary" : isGreen ? "secondary" : "inherit"}
        size="medium"
        component="label"
        style={style}
        onClick={onClick}
        disabled={disable}
        disableElevation
      >
        {children}
      </Button>
    </Box>
  );
}
